<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <card-component titulo="Lista dos pacientes" componente="null" usuario="null">
                    <template v-slot:conteudo>
                        <div class="row">
                            <div class="col mb-3">
                                <input-container-component titulo="Nome" id="inputNome">
                                    <input type="text" class="form-control" id="inputNome" placeholder="Informe o Nome"
                                        v-model="busca.nome" @keyup="pesquisar()">
                                </input-container-component>
                            </div>
                            <div class="col-3 mb-3" v-if="userJson.nivel_acesso == 'adm'">
                                <input-container-component titulo="Caps">
                                    <select name="caps_lan" class="form-control" id="caps_lan" @change="filtroCaps">
                                        <option selected></option>
                                        <option value="1">Sede</option>
                                        <option value="2">Novo Tempo</option>
                                        <option value="5">David Capstrano</option>
                                        <option value="6">Estação</option>
                                        <option value="7">Integração</option>
                                        <option value="9">Toninho</option>
                                        <option value="10">Esperanca</option>
                                    </select>
                                </input-container-component>
                            </div>
                        </div>
                        <table-component :dados="pacientes.data" componentpai="pacientes" :editar="{
                            visivel: true,
                            dataToggle: 'modal',
                            dataTarget: '#modalPacientesAtualizar'
                        }" :remover="{
                            visivel: true,
                            dataToggle: 'modal', 
                            dataTarget: '#modalPacientesRemover'
                        }" :titulos="{
                            id: { titulo: '', tipo: '' },
                            nome: { titulo: 'Nome', tipo: 'texto' },
                            conta_contabil_reduzido: { titulo: 'Código Conta Caixa', tipo: 'texto' },
                            centro_custo: { titulo: 'Centro Custo', tipo: 'texto' },
                            status: { titulo: 'Status', tipo: 'texto' },
                            caps: { titulo: 'Caps Paciente', tipo: '' }
                        }"></table-component>
                    </template>
                    <template v-slot:rodape>
                        <div class="row">
                            <div class="col-10">
                                <paginate-component>
                                    <li v-for="l, key in pacientes.links" :key="key"
                                        :class="l.active ? 'page-item active' : 'page-item'"><a class="page-link"
                                            v-html="l.label" @click="paginacao(l)"></a></li>
                                </paginate-component>
                            </div>
                            <div class="col-2">
                                <button type="button" class="btn btn-primary btn-sm float-end" data-bs-toggle="modal"
                                    data-bs-target="#modalPaciente">
                                    Adicionar
                                </button>
                            </div>
                        </div>
                    </template>
                </card-component>
            </div>
        </div>
        <modal-component id="modalPaciente" titulo="Adicionar Paciente">
            <template v-slot:alertas>
                <alert-component tipo="success" :detalhes="transacaoDetalhes" titulo="Cadastro realizado com sucesso!"
                    v-if="transacaoStatus == 'sucesso'"></alert-component>
                <alert-component tipo="danger" :detalhes="transacaoDetalhes" titulo="Erro ao cadastrar."
                    v-if="transacaoStatus == 'erro'"></alert-component>
            </template>
            <template v-slot:conteudo>
                <div class="form-group">
                    <input-container-component titulo="Nome Paciente" id="novoNome">
                        <input type="text" class="form-control" id="novoNome" placeholder="Informe o Nome do Paciente"
                            v-model="nomePaciente">
                    </input-container-component>
                </div>
                <div class="form-group mt-3">
                    <input-container-component titulo="Código Conta Caixa" id="novoCodContaCaixa">
                        <input type="text" class="form-control" id="novoCodContaCaixa"
                            placeholder="Informe o Código Conta Caixa" v-model="codContaCaixa">
                    </input-container-component>
                </div>
                <div class="form-group mt-3">
                    <input-container-component titulo="Centro de Custo" id="novoCodCentroCusto">
                        <input type="text" class="form-control" id="novoCodCentroCusto"
                            placeholder="Informe o Centro de Custo" v-model="centroCusto">
                    </input-container-component>
                </div>
                <div class="form-group mt-3">
                    <input-container-component titulo="Caps">
                        <select name="caps_paciente" class="form-control" id="caps_paciente" v-model="capsId">
                            <option value=""></option>
                            <option value="1">Sede</option>
                            <option value="2">N. Tempo</option>
                            <option value="3">Criativo</option>
                            <option value="4">Carretel</option>
                            <option value="5">David Capstrano</option>
                            <option value="6">Estacao</option>
                            <option value="7">Integracao</option>
                            <option value="8">Independencia</option>
                            <option value="9">Toninho</option>
                            <option value="10">Esperanca</option>
                            <option value="11">Reviver</option>
                            <option value="12">A. Orlando</option>
                        </select>
                    </input-container-component>
                </div>
            </template>
            <template v-slot:rodape>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
                <button type="button" class="btn btn-primary" @click="salvar()">Salvar</button>
            </template>
        </modal-component>

        <modal-component id="modalPacientesAtualizar" titulo="Atualizar Paciente">
            <template v-slot:alertas>
                <alert-component tipo="success" :detalhes="$store.state.transacao.mensagem"
                    titulo="Paciente atualizado com sucesso!"
                    v-if="$store.state.transacao.status == 'sucesso'"></alert-component>
                <alert-component tipo="danger" :detalhes="$store.state.transacao.mensagem" titulo="Erro ao atualizar."
                    v-if="$store.state.transacao.status == 'erro'"></alert-component>
            </template>
            <template v-slot:conteudo>
                <div class="form-group">
                    <input-container-component titulo="Nome Paciente" id="atualizarNome">
                        <input type="text" class="form-control" id="atualizarNome"
                            placeholder="Informe o Nome do Paciente" v-model="$store.state.item.nome">
                    </input-container-component>
                </div>
                <div class="form-group mt-3">
                    <input-container-component titulo="Código Conta Caixa" id="atualizarCodContaCaixa">
                        <input type="text" class="form-control" id="atualizarCodContaCaixa"
                            placeholder="Informe o Código Conta Caixa"
                            v-model="$store.state.item.conta_contabil_reduzido">
                    </input-container-component>
                </div>
                <div class="form-group mt-3">
                    <input-container-component titulo="Centro de Custo" id="atualizarCodCentroCusto">
                        <input type="text" class="form-control" id="atualizarCodCentroCusto"
                            placeholder="Informe o Centro de Custo" v-model="$store.state.item.centro_custo">
                    </input-container-component>
                </div>
                <div class="form-group mt-3">
                    <input-container-component titulo="Caps">
                        <select name="caps_paciente" class="form-control" id="caps_paciente" v-model="$store.state.item.caps_id">
                            <option value="1">Sede</option>
                            <option value="2">N. Tempo</option>
                            <option value="3">Criativo</option>
                            <option value="4">Carretel</option>
                            <option value="5">David Capstrano</option>
                            <option value="6">Estacao</option>
                            <option value="7">Integracao</option>
                            <option value="8">Independencia</option>
                            <option value="9">Toninho</option>
                            <option value="10">Esperanca</option>
                            <option value="11">Reviver</option>
                            <option value="12">A. Orlando</option>
                        </select>
                    </input-container-component>
                </div>
                <div class="form-group mt-3">
                    <input-container-component titulo="Caps">
                        <select name="caps_paciente" class="form-control" id="caps_paciente" v-model="$store.state.item.status">
                            <option value="ativo">Ativo</option>
                            <option value="inativo">Inativo</option>
                        </select>
                    </input-container-component>
                </div>
            </template>
            <template v-slot:rodape>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
                <button type="button" class="btn btn-primary" @click="atualizarPaciente()">Atualizar</button>
            </template>
        </modal-component>

        <modal-component id="modalPacientesRemover" titulo="Remover Paciente">
            <template v-slot:alertas>
                <alert-component tipo="success" :detalhes="$store.state.transacao.mensagem"
                    titulo="Paciente removido com sucesso!"
                    v-if="$store.state.transacao.status == 'sucesso'"></alert-component>
                <alert-component tipo="danger" :detalhes="$store.state.transacao.mensagem" titulo="Erro ao remover."
                    v-if="$store.state.transacao.status == 'erro'"></alert-component>
            </template>
            <template v-slot:conteudo v-if="$store.state.transacao.status != 'sucesso'">
                <div class="form-group">
                    <input-container-component titulo="Nome Paciente" id="atualizarNome">
                        <input type="text" class="form-control" id="atualizarNome"
                            placeholder="Informe o Nome do Paciente" v-model="$store.state.item.nome" disabled>
                    </input-container-component>
                </div>
                <div class="form-group mt-3">
                    <input-container-component titulo="Código Conta Caixa" id="atualizarCodContaCaixa">
                        <input type="text" class="form-control" id="atualizarCodContaCaixa"
                            placeholder="Informe o Código Conta Caixa"
                            v-model="$store.state.item.conta_contabil_reduzido" disabled>
                    </input-container-component>
                </div>
                <div class="form-group mt-3">
                    <input-container-component titulo="Centro de Custo" id="atualizarCodCentroCusto">
                        <input type="text" class="form-control" id="atualizarCodCentroCusto"
                            placeholder="Informe o Centro de Custo" v-model="$store.state.item.centro_custo" disabled>
                    </input-container-component>
                </div>
            </template>
            <template v-slot:rodape>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
                <button type="button" class="btn btn-danger" @click="removerPaciente()"
                    v-if="$store.state.transacao.status != 'sucesso'">Remover</button>
            </template>
        </modal-component>
    </div>
</template>

<script>
export default {
    props: ['user'],
    data() {
        return {
            urlBase: 'https://contasmoradores.candido.org.br/api/v1/paciente-cx',
            urlPaginacao: '',
            urlFiltro: '',
            pacientes: { data: [] },
            nomePaciente: '',
            codContaCaixa: '',
            centroCusto: '',
            capsId: '',
            transacaoStatus: '',
            transacaoDetalhes: {},
            busca: { nome: '' },
            links: {}
        }
    },
    methods: {
        resetTransacao() {
            this.transacaoStatus = ''
            this.transacaoDetalhes = ''
            this.nomePaciente = ''
            this.codContaCaixa = ''
            this.centroCusto = ''
        },
        filtroCaps(e) {
            this.busca.caps_id = e.target.value
            this.pesquisar()
        },
        atualizarPaciente() {
            let formData = new FormData()
            formData.append('_method', 'patch')
            formData.append('nome', this.$store.state.item.nome)
            formData.append('conta_contabil_reduzido', this.$store.state.item.conta_contabil_reduzido)
            formData.append('centro_custo', this.$store.state.item.centro_custo)
            formData.append('historico', '0040')
            formData.append('status', this.$store.state.item.status)
            formData.append('caps_id', this.$store.state.item.caps_id)


            let config = {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }

            axios.post(this.urlBase + '/' + this.$store.state.item.id, formData, config)
                .then(response => {
                    this.carregarLista()
                    this.$store.state.transacao.status = 'sucesso'
                    this.$store.state.transacao.mensagem = response.data
                })
                .catch(errors => {
                    this.$store.state.transacao.status = 'erro'
                    this.$store.state.transacao.mensagem = {
                        mensagem: errors.response.data.mensagem,
                        dados: errors.response.data.errors
                    }
                })
        },
        removerPaciente() {
            let confirmacao = confirm('Confirmar remoção do registro!')

            if (!confirmacao) return false

            let formData = new FormData()
            formData.append('_method', 'delete')

            let config = {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }

            axios.post(this.urlBase + '/' + this.$store.state.item.id, formData, config)
                .then(response => {
                    this.carregarLista()
                    this.$store.state.transacao.status = 'sucesso'
                    this.$store.state.transacao.mensagem = response.data
                })
                .catch(errors => {
                    this.$store.state.transacao.status = 'erro'
                    this.$store.state.transacao.mensagem = {
                        mensagem: errors.response.data.mensagem,
                        dados: errors.response.data.errors
                    }
                })
        },
        pesquisar() {
            let filtro = ''
            for (let chave in this.busca) {
                if (this.busca[chave]) {
                    if (filtro != '') {
                        filtro += ';'
                    }
                    filtro += chave + ':like:' + this.busca[chave]
                }
            }
            if (filtro != '') {
                this.urlPaginacao = 'page=1'
                this.urlFiltro = '&filtro=' + filtro + '%'
            } else {
                this.urlFiltro = ''
            }
            this.carregarLista()
        },
        paginacao(l) {
            if (l.url) {
                this.urlPaginacao = l.url.split('?')[1]
                this.carregarLista()
            }
        },
        carregarLista() {
            let url = this.urlBase + '?' + this.urlPaginacao + this.urlFiltro

            let config = {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }
            axios.get(url, config)
                .then(response => {
                    this.pacientes = response.data
                })
                .catch(errors => {
                })
        },
        salvar() {
            let formData = new FormData()

            formData.append('nome', this.nomePaciente)
            formData.append('conta_contabil_reduzido', this.codContaCaixa)
            formData.append('centro_custo', this.centroCusto)
            formData.append('historico', '0040')
            formData.append('status', 'ativo')
            formData.append('caps_id', this.capsId)

            let config = {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }

            axios.post(this.urlBase, formData, config)
                .then(response => {
                    this.carregarLista()
                    this.transacaoStatus = 'sucesso'
                    this.transacaoDetalhes = {
                        mensagem: 'ID do registro: ' + response.data.id
                    }
                })
                .catch(errors => {
                    console.log(errors.response)
                    this.transacaoStatus = 'erro'
                    this.transacaoDetalhes = {
                        mensagem: errors.response.data.mensagem,
                        dados: errors.response.data.errors
                    }
                })
        }
    },
    mounted() {
        this.carregarLista()
        // Obtém o elemento da modal pelo ID
        const modalElement = document.getElementById('modalPaciente');

        // Adiciona o evento de fechamento da modal para resetar as variáveis
        modalElement.addEventListener('hidden.bs.modal', this.resetTransacao);
    },
    beforeUnmount() {
        // Remove o evento ao desmontar o componente para evitar vazamento de memória
        const modalElement = document.getElementById('modalPaciente');
        modalElement.removeEventListener('hidden.bs.modal', this.resetTransacao);
    },
    computed: {
        token() {
            let token = 'Bearer ' + document.cookie.split(';').find(indice => {
                return indice.includes('token=')
            }).split('=')[1]
            return token
        },

        userJson() {
            return JSON.parse(this.user);
        },
    },
}
</script>
